module.exports = __webpack_public_path__ + "static/media/ReviLogo.c181a687.avif";